export const GET_DROP_DOWN_LIST_DATA = "GET_DROP_DOWN_LIST_DATA";
export const GET_DROP_DOWN_LIST_DATA_SUCCESS = "GET_DROP_DOWN_LIST_DATA_SUCCESS";
export const GET_DROP_DOWN_LIST_DATA_ERROR = "GET_DROP_DOWN_LIST_DATA_ERROR";
